import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ISmsCodeField {
	settingsId: string;
	onChange: (value: string) => void;
}

const SmsCodeField: React.FC<ISmsCodeField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [{ required: false, pattern: /^\d{6}$/, message: t('smsCodeInvalidLength') }],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const trimmed = e.target.value.trim();
			onChange(trimmed);
			return trimmed;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="SmsCodeField"
			name={`smsCode-${settingsId}`}
			label="smsCodeLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(SmsCodeField);
